




































































import datasetService from '@/services/dataset.service';
import { DataSet, Integration } from '@/types';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CancelButton from './CancelButton.vue';
import ConfirmButton from './ConfirmButton.vue';
import Dialog from './Dialog.vue';
import IntegrationIcon from './IntegrationIcon.vue';

@Component({
  components: {
    IntegrationIcon,
    Dialog,
    CancelButton,
    ConfirmButton,
  },
})
export default class RemoveIntegrationModal extends Vue {
  @Prop({ default: false }) private show!: boolean;
  @Prop() private integration!: Partial<Integration>;

  private datasetDetails: DataSet[] = [];

  @Watch('show')
  private async handleShowChange(value: boolean) {
    if (!value) {
      this.datasetDetails = [];
    } else if (value && this.integration && this.datasetIntegrations.length > 0) {
      const responses = await Promise.all(this.datasetIntegrations.map((i: any) => datasetService.getDataSetById(i.entityId)));
      this.datasetDetails = responses;
    }
  }

  private get deviceManagementIntegrations() {
    if (!this.integration || !this.integration.configurations) {
      return [];
    }

    return this.integration.configurations.filter((config) => config.type === 'device');
  }

  private get datasetIntegrations() {
    if (!this.integration || !this.integration.configurations) {
      return [];
    }

    return this.integration.configurations.filter((config) => config.type === 'dataset');
  }

  private get preventConfirm() {
    return this.deviceManagementIntegrations.length + this.datasetIntegrations.length !== 0;
  }

  private get datasetsWithFilters() {
    return this.datasetDetails.map((dataset: DataSet) => ({
      ...dataset,
      filters: JSON.parse(dataset.filters),
    }));
  }
}
